import {Injectable} from '@angular/core';
import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {ReportComponentSummaryModel} from '../reportComponentSummary.model';
import {ReportComponentDefinitionConverter} from '../../../../report-component-definition/api/entity/converter/reportComponentDefinition.converter';
import {UserSummaryConverter} from '../../../../../account/modules/user/api/converter/userSummary.converter';
import {AccountSummaryConverter} from '../../../../../account/common/api.converter/AccountSummary.converter';
import {OfficeSummaryConverter} from "../../../../../office/api/model/converter/officeSummary.converter";

@Injectable()
export class ReportComponentSummaryConverter extends HttpModelConverter<ReportComponentSummaryModel> {

    constructor(private definitionConverter: ReportComponentDefinitionConverter,
                private officeSummaryConverter: OfficeSummaryConverter,
                private accountSummaryConverter: AccountSummaryConverter,
                private userSummaryConverter: UserSummaryConverter) {
        super();
    }

    protected createInstance(): ReportComponentSummaryModel {
        return new ReportComponentSummaryModel();
    }

    protected enrichObject(result: ReportComponentSummaryModel, src: ReportComponentSummaryModel) {
        result.definition = this.definitionConverter.convert(src.definition);
        result.user = this.userSummaryConverter.convert(src.user);
        result.account = this.accountSummaryConverter.convert(src.account);
        result.office = this.officeSummaryConverter.convert(src.office)
    }


}
